import  {React,useLayoutEffect, useRef, useState, useCallback, useEffect} from "react";
import { useNavigate } from "react-router";
import { motion } from "framer-motion";
import styled  from "styled-components";
import imgIPCAR from './img/ip-car-thumbnail.jpg';
import imgRAUM from './img/raum-utrecht.jpg';
import imgVPRORADIO from './img/arbeidsvitaminen.jpg';

let viewPortWith = null
let viewPortHeight = null 
let pageLoad= false;

let positionTopMobile =0
let positionMiddleMobile =0
let positionBottomMobile =0

const Container = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
    color: white;
    padding-top: 10px;
    //background: #0b2bf1;
    font-family: 'Montserrat', sans-serif;
    h1{
      margin:0;
      text-align: center;
    }
    .videoInfo{
        display: inline;
    }
    p{
      width: 60%;
      margin-left:20%;
      
    }
    `
// styling Desktop////////
const Swiper = styled.div.attrs(props=>({ style: {right: `${props.posistionElement}px`}}))`
  position: relative;
  //background: #eb3434;
  width: 100%;
  height: 500px;
  overflow:hidden;
  font-family: 'Rajdhani', sans-serif;

  `

const SlideLeft = styled.div`
   font-family: 'Rajdhani', sans-serif;
    background-image: url(${imgRAUM});
    background-size: cover;
    background-position: center;
    background-blend-mode: multiply;
    display: inline-block;
    position: absolute;
    top: 50%;
    left:3%;
    margin-top: -65px;
    width: 17%;
    height: 130px;
    -webkit-background-clip: padding-box;
    `
const SlideMiddle = styled.div`
  background-image: url(${imgIPCAR});
  background-size: cover;
  background-position: center;
  background-blend-mode: multiply;
  display: inline-block;
  position: absolute;
  top: 50%;
  left: 30%;
  margin-top: -200px;
  width: 40%;
  height: 400px;
  opacity: 0.9;
 
  `

const SlideRight = styled.div`
 background-image: url(${imgVPRORADIO});
    background-size: cover;
    background-position: center;
    background-blend-mode: multiply;
    display: inline-block;
    position: absolute;
    top: 50%;
    right:3%;
    margin-top: -65px;
    width: 17%;
    height: 130px;
  `
// styling mobile/////////////////////////////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////////////////////////////////////
  
const SwiperMobile = styled.div.attrs(props=>({ style: {right: `${props.posistionElement}px`}}))`
position: relative;
//background: #eb3434;
width: 100%;
height: 1000px;
overflow:hidden;

h1{   position: absolute;
      bottom: -20%;
      width: 100%;
      transform: translateX();
      -webkit-transform: translateX();
      -ms-transform: translateX();
      margin:0;
      text-align: center;
    }
`

const SlideTopMobile  = styled.div`
    background-image: url(${imgRAUM});
    background-size: cover;
    background-position: center;
    background-blend-mode: multiply;
    position: absolute;
    left:10%;
    width: 80%;
    height: 200px;
    -webkit-background-clip: padding-box;
    `
const SlideMiddleMobile = styled.div`
  background-image: url(${imgIPCAR});
  background-size: cover;
  background-position: center;
  background-blend-mode: multiply;
  position: absolute;
  top: 35%;
  width: 80%;
  left:10%;
  height: 200px;
  opacity: 0.9;
 
  `

const SlideBottomMobile = styled.div`
 background-image: url(${imgVPRORADIO});
    background-size: cover;
    background-position: center;
    background-blend-mode: multiply;
    position: absolute;
    bottom: 10%;
    width: 80%;
    left:10%;
    height: 200px;
`


function Portfolio(props) {

  let [positionElement, setpositionElement] = useState(0) // is used to update a value after dom is rendered
  /// desktop variable
  let [leftX, setleftX] = useState(0) 
  let [leftScale, setLeftScale] = useState(1) 
  let [middleX, setMiddleX] = useState(0)
  let [middleScale, setMiddleScale] = useState(1) 
  let [rightX, setRightX] = useState(0) 
  let [rightScale, setRightScale] = useState(1) 
  /// mobile variable

  let [topMobileScale, setTopScale] = useState(1) 
  let [middleMobileScale, setMiddleMobileScale] = useState(1) 
  let [bottomMobileScale, setBottomScale] = useState(1) 
  let [device, setDevice] = useState(true) 

  let refSwiper = useRef()
  let refSlide = useRef() 
  let refTopMobile = useRef()
  let refMiddleMobile = useRef()
  let refBottomMobile = useRef()

  let navigate = useNavigate(); // navigate react function
  

  function map( x,  in_min,  in_max,  out_min,  out_max){ // maps de waardes 
    return Math.round((x - in_min) * (out_max - out_min) / (in_max - in_min) + out_min)
  }
  function mapScale( x,  in_min,  in_max,  out_min,  out_max){ // maps de waarde naar een coma getal met 3 cijfers achter de coma
    return Math.round(((x - in_min) * (out_max - out_min) / (in_max - in_min) + out_min)*1000)/1000
  }

  function mapMiddleScale( x, smallSize, bigSize){ //makes the scall for the middle element 

    let middlepoint = viewPortWith/2
    
    if (x<middlepoint){ // left side
       return mapScale(x, 0,middlepoint, smallSize,bigSize)
    }

    if (x>middlepoint){ // right side
      return mapScale(x, middlepoint,viewPortWith, bigSize,smallSize)
   }
  }

  function handleMouseMove(e){ // function for changen header background  gradient
    viewPortWith = window.innerWidth;

    //position1 = (e.clientX/viewPortWith*100).toFixed(0) // curent mouse postion in a range from 0 to 100 procent
   
    leftX= map(e.clientX,0,viewPortWith, 40,-25);
    leftScale= mapScale(e.clientX,0,viewPortWith, 1.6,0.7);
    middleX= map(e.clientX,0,viewPortWith, 50,-50);
    rightX= map(e.clientX,0,viewPortWith, 25,-40);
    rightScale= mapScale(e.clientX,0,viewPortWith, 0.7,1.6);

    setleftX(leftX )
    setLeftScale(leftScale)
    setMiddleX(middleX )
    setRightX(rightX )
    setRightScale(rightScale)
    setpositionElement()
   
  }

  function outSideMouseMove(e){ // scale of middle element when mouse is on the left or right element
    viewPortWith = window.innerWidth;

    //position1 = (e.clientX/viewPortWith*100).toFixed(0) // curent mouse postion in a range from 0 to 100 procent
    middleScale= mapMiddleScale(e.clientX, 0.8,1.2);
   
    setMiddleScale(middleScale)
   
  }
  //element risize mobile

  let mapMobileScale= useCallback((elementY,scrollY,smallSize,bigSize ) => {

    //console.log(elementY)
   
    let middlepoint = viewPortHeight/2
   
    if (elementY<middlepoint){ // above middle
      
       return mapScale(elementY, 0,middlepoint, smallSize, bigSize)
    }

    if (elementY>middlepoint){ // below middle
      return mapScale(elementY, middlepoint,viewPortHeight,bigSize,smallSize)
   }

  })

  useEffect(()=>{
    

  if(device === false){// device is mobile this function is inside useEffect because of dom load
      //console.log("hoi")
      positionTopMobile = refTopMobile.current.getBoundingClientRect().y // getboundingClientRect only works with a small delay of 0.1 mili seconde
       positionMiddleMobile = refMiddleMobile.current.getBoundingClientRect().y 
     positionBottomMobile = refBottomMobile.current.getBoundingClientRect().y 
      //console.log(positionMiddleMobile)//positionMiddleMobile

      setTopScale(mapMobileScale(  positionTopMobile, props.scrollPercentage,0.8,1.1)) //element y position, scrollpercentage, minsize, maxsize
      setMiddleMobileScale(mapMobileScale(  positionMiddleMobile, props.scrollPercentage,0.8,1.1)) //element y position, scrollpercentage, minsize, maxsize
      setBottomScale(mapMobileScale(  positionBottomMobile, props.scrollPercentage,0.8,1.1)) //element y position, scrollpercentage, minsize, maxsize
      //console.log( middleMobileScale)
    }
  })

  useLayoutEffect(() => {

  
    if(pageLoad === false ){
        viewPortHeight = window.innerHeight;
        if (window.innerWidth >1000){ // switch between mobile and desktop mode
          setDevice(true)
          //console.log("desktop")
        }else{
          setDevice(false)
          //console.log("mobile")       

        // mobile javascript is below

        }
    
    }
    //pageLoad = true

    
  },[mapMobileScale, props.scrollPercentage]);


  return (
    <Container>
      <div className="videoInfo">
            {device? 
            <Swiper posistionElement={positionElement}  onMouseMove={(e)=>handleMouseMove(e)} ref={refSwiper}> 
              <SlideLeft  onClick={()=>{navigate("/raum")}} onMouseEnter={(e)=>props.elementEnter(1)} onMouseLeave={(e)=>props.elementEnter(0)} onMouseMove={(e)=>outSideMouseMove(e)} ref={refSlide} as={motion.div} 
              animate={{ x: leftX, scale: leftScale}}
            
              
              >
                <h1>Harmony</h1>
              </SlideLeft>
              <SlideMiddle onClick={()=>{navigate("/ip-car")}} onMouseEnter={(e)=>props.elementEnter(1)} onMouseLeave={(e)=>props.elementEnter(0)} as={motion.div} animate={{
                    x: middleX,
                    scale: middleScale
                }}
                >
                <h1>IP-CAR</h1>
              </SlideMiddle>
              <SlideRight   onClick={()=>{navigate("/arbeidsvitamine")}} onMouseEnter={(e)=>props.elementEnter(1)} onMouseLeave={(e)=>props.elementEnter(0)} onMouseMove={(e)=>outSideMouseMove(e)} as={motion.div} animate={{
                    x: rightX,
                    scale: rightScale
                }}>
                <h1>Arbeidsvitamine</h1>
              </SlideRight>
            </Swiper>
            : // //////////////if device is false show mobile state
            <SwiperMobile>
              <SlideTopMobile onClick={()=>{navigate("/raum")}}  ref={refTopMobile} as={motion.div} 
                  animate={{ scale: topMobileScale}}
                  transition={{ type: "Inertia", bounce: 0}}>
                  <h1>Harmony</h1>
              </SlideTopMobile>
              <SlideMiddleMobile onClick={()=>{navigate("/ip-car")}} ref={refMiddleMobile} as={motion.div} 
                  animate={{ scale: middleMobileScale}}
                  transition={{ type: "Inertia", bounce: 0}}>
                  <h1>IP-CAR</h1>
              </SlideMiddleMobile>
              <SlideBottomMobile onClick={()=>{navigate("/arbeidsvitamine")}} ref={refBottomMobile} as={motion.div} 
                  animate={{ scale: bottomMobileScale}}
                  transition={{ type: "Inertia", bounce: 0}}>
                  <h1>Arbeidsvitamine</h1>
              </SlideBottomMobile>
            </SwiperMobile>
           }
      </div>
    </Container>
  );
}
export default Portfolio;